import {Injectable} from '@angular/core';
import {IProdGridService} from 'prod-grid';
import {HttpClient} from "@angular/common/http";
import {HttpExtraParams} from 'prod-shared';
import {Observable} from 'rxjs';
import {AuditLog} from "../models/audit-log";

@Injectable({
  providedIn: 'root'
})
export class AuditlogService implements IProdGridService {
  constructor(private httpClient: HttpClient) {
  }

  getProdGridData(params?: HttpExtraParams): Observable<Object> {
    return this.httpClient.get<{ data: { result: AuditLog[], totalCount: number }, success: boolean }>(`/api/auditlogs`, {params});
  }
}
